import { ICounselorInfo } from '../../../interfaces/api/I-api-hrs-users';

/**
 * @note ag-grid 에 현재 그려진 데이터 추출하는 함수 (상담사 그리드 뽑음)
 */
export function getExistingData(gridApi: any): ICounselorInfo[] {
  const existingData: ICounselorInfo[] = [];

  gridApi.forEachNode((node: any) => {
    if (node.data) {
      existingData.push(node.data);
    }
  });

  return existingData;
}

/**
 * @note 추가될 사용자들 bid 기준으로 이미 필터링함
 */
export function filterNewUsers(existingData: ICounselorInfo[], selectedUsers: ICounselorInfo[]): ICounselorInfo[] {
  const existingBids = new Set(existingData.map((user) => user.bid));

  return selectedUsers.filter((user) => !existingBids.has(user.bid));
}
